import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export type i18nLocales = "en" | "de" | "fr" | "es" | "pt" | "nl";

export const routing = defineRouting({
  locales: ["en", "de", "fr", "es", "pt", "nl"],
  defaultLocale: "en",
});

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
